import React from "react";
import { WizAuthority } from "@/containers/common";
import { framework_tool, component_tool } from '@/tool'
const { WizSpin, WizCard, WizEmpty, WizInput, WizRow, WizCol, WizTable, WizModal, WizBraftEditor } = component_tool;
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { AuditForm } from './components'
const { ossFileUtils } = framework_tool

const getContentType = contentType => {
  switch (contentType) {
    case 1:
      return '文章';
    case 2:
      return '图片';
    case 3:
      return '视频'
    case 4:
      return '文档'
    case 5:
      return '下载文件'
  }
}

const getStatus = releaseState => {
  switch (releaseState) {
    case 0:
      return '草稿';
    case 1:
      return '已发布';
    case 2:
      return '取消发布'
    case 3:
      return '已关闭'
  }
}

const getPlatform = releasePlatform => {
  if (!releasePlatform) return
  const map = { '1': "PC", '2': 'APP', '3': '凯迪拉克IQ', '4': '小程序', '5': '雪佛兰企微', '6': '别克企微', '7': '凯迪拉克企微' }


  const textArr = releasePlatform.toString().split(',');
  const arr = [];
  for (let index = 0; index < textArr.length; index++) {
    arr.push(map[textArr[index]])
  }
  return arr.join(',').replace(/\,/g, ' ')
}

export default (record = {}, openLook = () => { }, openRichText = () => { }) => {
  let { notice = {}, featured = {}, trainPath = {}, task = {}, contentList = [] } = record?.detailValue || {}
  const platformList = [
    { value: 0, label: 'PC' },
    { value: 1, label: 'APP' },
    { value: 2, label: '凯迪拉克IQ' },
    { value: 3, label: '雪佛兰企微' },
    { value: 4, label: '别克企微' },
    { value: 5, label: '凯迪拉克企微' },
  ]
  const positionsList = [
    { value: 0, label: '首页轮播' },
    { value: 1, label: '广告位' },
    { value: 2, label: '路径推荐位' },
  ]
  const formatList = (list, item) => {
    return list.find(x => x.value == item).label || ''
  }

  const columns = [
    {
      title: '排序',
      dataIndex: 'orderNum',
      key: 'orderNum',
      width: 60
    },
    {
      title: '课程内容名称',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      ellipsis: true,
      render: (text, record) => {
        return (<a onClick={() => openLook(record)}>{text}</a>
        )
      }
    },
    {
      title: '类型',
      dataIndex: 'contentType',
      key: 'contentType',
      width: 60,
      render: (text) => text == 0 ? '课件' : '考试'
    },
    {
      title: '内容类型',
      dataIndex: 'fileType',
      key: 'fileType',
      width: 100,
      render: (text) => text == 0 ? '文件' : '文件地址'
    }
  ];

  return [
    { label: '培训公司名称', value: record.trainCompanyName },
    { label: '申请人姓名', value: record.applicantFullName },
    { label: '申请人账号', value: record.applicantUserName },
    { label: '联系电话', value: record.telephone },
    { label: '课程名称', value: record.programName },
    { label: '品牌', value: record.brandCh },
    { label: '功能块', value: record.moduleCh },
    { label: '序号', value: record.orderNumber },
    { label: '版本号', value: record.programScoId },
    { label: '开发/更新完成时间', value: record.programFinishDate },
    { label: '课程编码', value: record.programScoId },
    { label: '课程时间', value: `${record.startDate} ~ ${record.endDate}` },
    { label: '课程分类', value: record.programCategoryNames },
    {
      label: '封面', value: <PhotoProvider
        toolbarRender={({ onScale, scale }) => {
          return (
            <>
              <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} />
              <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} />
            </>
          );
        }}>
        <div className="foo">
          <PhotoView key={'img_' + record.imgOne} src={getOssFilePath(record.imgOne)}>
            <a>查看</a>
          </PhotoView>
        </div>
      </PhotoProvider>
    },
    {
      label: '介绍', value: <a onClick={() => openRichText(record.intro)}>查看</a>,
      // { label: '介绍', value:<div id='knowledge_intro'> {_createIntro(record.intro)} </div>

    },
    { label: '受众', value: <WizAuthority value={record.authData} mode='Show' showBlock={false} /> },
    {
      label: '路径设置', value:
        <div>
          <div>{trainPath?.trainPathStageList?.length > 0 && trainPath.trainPathStageList.map(item => {
            return (
              <div>
                {item.pathName}.{item.stageName}
              </div>
            )
          })}</div>
        </div>
    },
    {
      label: '消息通知', value:
        <div>
          <div>是否消息通知：{notice?.state == 0 ? '否' : '是'}</div>
          <div>通知方式：{notice?.way?.length > 0 && notice.way.map((item, index) => {
            return (
              <span>{item}{index == notice.way.length - 1 ? '' : '、'}</span>
            )
          })}</div>
          <div>通知白名单：{notice?.noticeWhitelist == 0 ? '否' : '是'}</div>
        </div>
    },
    {
      label: '推荐设置', value:
        <div>
          <div>是否推荐：{featured.state == 0 ? '否' : '是'}</div>
          <div>推荐生效时间： {`${featured.startTime} ~ ${featured.endTime}`} </div>
          <div>推荐平台：{featured?.platforms?.length > 0 && featured.platforms.map((item, index) => {
            return (
              <span>{formatList(platformList, item)}{index == featured.platforms.length - 1 ? '' : '、'}</span>
            )
          })}</div>
          <div>推荐位：{featured?.positions?.length > 0 && featured.positions.map((item, index) => {
            return (
              <span>{formatList(positionsList, item)}{index == featured.positions.length - 1 ? '' : '、'}</span>
            )
          })}</div>
        </div>
    },
    {
      label: '任务设置', value:
        <div>
          <div>是否添加到任务：{task.state == 0 ? '否' : '是'}</div>
          <div>通知方式：{task?.way?.length > 0 && task?.way.map((item, index) => {
            return (
              <span>{item}{index == task.way.length - 1 ? '' : '、'}</span>
            )
          })}</div>
          <div>是否通知白名单：{task?.noticeWhitelist == 0 ? '否' : '是'}</div>
        </div>
    },
    {
      label: '课件内容', value: <>
        <WizTable pagination={false} columns={columns} dataSource={contentList} />

      </>

    },

  ].filter(item => !!item)
}
